export default __webpack_public_path__ + "img/app-page/screen3.0cd425bdd8b10e05cadfa8ac6c0ed495.png";